'use client'

import { useEffect } from 'react'

import {
  GoogleTagManagerEvent,
  useGoogleTagManagerTrack,
} from '@marketplace-web/google-track/google-track-feature'
import { ItemDetailsSidebarSectionResp } from '@marketplace-web/item-page/item-page-data'

type Props = {
  item: ItemDetailsSidebarSectionResp
  children: React.ReactNode
}

const SidebarContentWrapper = ({ item, children }: Props) => {
  const { googleTagManagerTrack } = useGoogleTagManagerTrack()

  useEffect(() => {
    const value = parseFloat(item.price.amount)
    const price = parseFloat(item.discount?.amount || item.price.amount)
    const discount = Math.round((value - price) * 100) / 100
    googleTagManagerTrack(GoogleTagManagerEvent.ItemView, {
      item_name: item.title,
      item_id: item.id,
      value,
      price,
      discount,
      currency: item.currency,
      user_email: item.email,
      item_category_id: item.catalog_id,
      item_brand: item.brand_dto?.title,
      item_brand_id: item.brand_dto?.id,
      item_condition: 4,
    })
  }, [googleTagManagerTrack, item])

  return children
}

export default SidebarContentWrapper
